import React from "react";
import {
  Button,
  HeaderStyle,
  PageHeader,
  PageTitle,
} from "../../../../components";

const TitleList = () => {
  const tagLists = ["h1", "h2", "h3", "h4", "h5", "h6", "p"];

  return (
    <div className="w-full flex flex-1 flex-col gap-10 overflow-auto">
      <div className="flex flex-1 flex-col gap-5">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Title"} tag="h4" />
            </div>
          }
          RightSection={
            <div className="flex gap-2">
              <Button
                title={"Button"}
                size="sm"
                icon={"add"}
                variant="text"
                color="info"
              />
              <Button
                title={"Button"}
                size="sm"
                icon={"add"}
                variant="text"
                color="info"
              />
              <Button
                title={"Button"}
                size="sm"
                icon={"add"}
                variant="text"
                color="info"
              />
            </div>
          }
        />
      </div>
      <div className="flex flex-1 flex-col gap-5">
        <PageTitle title="Title" icon={"badge"} tag="h1" />
        <PageTitle title="Title" icon={"badge"} tag="h1" />
        <PageTitle title="Title" icon={"badge"} tag="h2" />
        <PageTitle title="Title" icon={"badge"} tag="h3" />
        <PageTitle title="Title" icon={"badge"} tag="h4" />
        <PageTitle title="Title" icon={"badge"} tag="h5" />
        <PageTitle title="Title" icon={"badge"} tag="h6" />
        <PageTitle title="Title" icon={"badge"} tag="p" />
      </div>
      <div className="flex flex-1 flex-col gap-5">
        <HeaderStyle title="Title" tag="h1" />
        <HeaderStyle title="Title" tag="h2" />
        <HeaderStyle title="Title" tag="h3" />
        <HeaderStyle title="Title" tag="h4" />
        <HeaderStyle title="Title" tag="h5" />
        <HeaderStyle title="Title" tag="h6" />
        <HeaderStyle title="Title" tag="p" />
      </div>
    </div>
  );
};

export default TitleList;
